<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>个人提现</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">个人提现</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="提现人名称">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入提现人名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.phone"
                    placeholder="请输入手机号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="编号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.id"
                    placeholder="请输入编号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    clearable
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="未处理" value="0"></el-option>
                    <!-- <el-option label="已到账" value="1"></el-option>
                    <el-option label="已退款" value="2"></el-option> -->
                    <el-option label="提现失败" value="3"></el-option>
                    <!-- <el-option label="冻结" value="4"></el-option> -->
                    <el-option label="已完成" value="5"></el-option>
                    <el-option label="打款中" value="7"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <div style="margin-bottom: 20px">
          <el-button type="primary" @click="InvoicingAll()" class="btn"
            >批量确认</el-button
          >
          <el-button type="primary" @click="exportList(1)" class="btn"
            >打款导出</el-button
          >
          <el-button type="primary" @click="exportList(2)" class="btn"
            >建设银行对账导出</el-button
          >
          <el-button type="primary" @click="exportList(3)" class="btn"
            >招商银行对账导出</el-button
          >
        </div>
        <TableScrollSlider :table-ref="$refs.multipleTable" />
        <el-table
          :data="tableData"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          tooltip-effect="dark"
          ref="multipleTable"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column
            prop="billDetailNo"
            label="编号"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="提现金额" align="center">
            <template slot-scope="scope">
              {{ scope.row.changeAmount | moneyFormat }}</template
            >
          </el-table-column>
          <el-table-column label="费率" align="center">
            <template slot-scope="scope"> {{ scope.row.rate * 100 }}%</template>
          </el-table-column>
          <el-table-column label="手续费" align="center">
            <template slot-scope="scope">
              {{ scope.row.commissionAmount | moneyFormat }}</template
            >
          </el-table-column>
          <el-table-column label="到账金额" align="center">
            <template slot-scope="scope">
              {{ scope.row.practicalAmount | moneyFormat }}</template
            >
          </el-table-column>
          <!-- <el-table-column label="钱包余额" align="center">
            <template slot-scope="scope">
              {{ scope.row.practicalAmount | moneyFormat }}</template
            >
          </el-table-column> -->
          <el-table-column label="保安账号" align="center">
            <template slot-scope="scope">
              {{ scope.row.practicalAmount | moneyFormat }}</template
            >
          </el-table-column>
          <el-table-column
            prop="memberTypeName"
            label="用户类型"
            align="center"
          >
          </el-table-column>
          <el-table-column label="提现人" align="center">
            <template slot-scope="scope">
              <div style="cursor: pointer" @click="goDetail(scope.row)">
                {{ scope.row.memberName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="开户行" align="center">
            <template slot-scope="scope">
              {{ scope.row.bankFullName }}</template
            >
          </el-table-column>
          <el-table-column label="开户行银行号" align="center" width="180">
            <template slot-scope="scope"> {{ scope.row.accountNo }}</template>
          </el-table-column>
          <el-table-column label="开户姓名" align="center">
            <template slot-scope="scope">{{ scope.row.realName }} </template>
          </el-table-column>
          <el-table-column label="开户绑定手机号" align="center" width="150">
            <template slot-scope="scope"> {{ scope.row.phone }}</template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              <span class="blueColor" v-if="scope.row.status == 0">未处理</span>
              <span class="greenColor" v-if="scope.row.status == 1"
                >已处理</span
              >
              <span class="greenColor" v-if="scope.row.status == 2"
                >已退款</span
              >
              <el-popover
                trigger="hover"
                placement="top"
                v-if="scope.row.status == 3"
              >
                <p>{{ scope.row.failDesc }}</p>
                <div slot="reference" class="name-wrapper">
                  <div class="redColor">提现失败</div>
                </div>
              </el-popover>
              <span class="greenColor" v-if="scope.row.status == 4">冻结</span>
              <span class="greenColor" v-if="scope.row.status == 5"
                >已完成</span
              >
              <span class="yellowColor" v-if="scope.row.status == 7"
                >打款中</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="创建时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <div
                class="disAround"
                v-if="scope.row.status == 0 || scope.row.status == 7"
              >
                <div class="operateBtn" @click="Invoicing(scope.row)">
                  确认提现
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="提现设置"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <el-select v-model="status" placeholder="请选择">
          <el-option label="提现成功" value="1"> </el-option>
          <el-option label="提现失败" value="0"> </el-option>
        </el-select>
        <div style="margin-top: 20px" v-if="status == '0'">失败描述：</div>
        <el-input
          v-if="status == '0'"
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="failDesc"
          style="margin-top: 5px"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confrim">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible1"
      width="40%"
      :before-close="handleClose1"
    >
      <div style="height: 350px; overflow-y: scroll">
        <div v-for="(item, index) in errorList" :key="index">{{ item }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible1 = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.financeData(),
      ruleForm: {
        name: "",
        status: "0",
        phone: "",
        id: "",
      },
      tableData: [],
      errorList: [],
      page: 1,
      pageSize: 20,
      total: 0,
      multipleTable: [],
      failDesc: "",
      dialogVisible: false,
      dialogVisible1: false,
      selectData: {},
      status: "",
      type: "0", //0 单独数据处理   1批量数据确认
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    goDetail(val) {
      if (val.memberType == 1) {
        this.$router.push({
          path: "/userDetail",
          query: {
            id: val.memberId,
          },
        });
      } else {
        this.$router.push({
          path: "/askariDetail",
          query: {
            id: val.memberId,
          },
        });
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.status = "";
      this.failDesc = "";
    },
    handleClose1() {
      this.dialogVisible1 = false;
    },
    exportList(key) {
      let arr = [];
      if (this.multipleTable.length != 0) {
        for (var i = 0; i < this.multipleTable.length; i++) {
          arr.push(this.multipleTable[i].id);
        }
      }
      let param = {
        queryParams: [],
        ids: arr,
      };
      if (this.ruleForm.name != "") {
        param.queryParams.push({
          name: "real_name",
          type: "input",
          value: this.ruleForm.name,
        });
      }
      if (this.ruleForm.phone != "") {
        param.queryParams.push({
          name: "phone",
          type: "input",
          value: this.ruleForm.phone,
        });
      }
      if (this.ruleForm.status != "") {
        param.queryParams.push({
          name: "status",
          type: "select",
          values: [{ itemKey: this.ruleForm.status }],
        });
      }
      let str = "";
      if (key == 1) {
        str = "/admapi/withdraw/tempexport";
      } else if (key == 2) {
        str = "/admapi/withdraw/financewithdrawexport";
      } else {
        str = "/admapi/withdraw/cmbwithdrawexport";
      }
      this.$axios
        .post(str, param, { responseType: "blob" })
        .then((data) => {
          console.log(data);
          this.$refs.multipleTable.clearSelection();
          let val = new Blob([data.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
          });
          let header = decodeURI(data.headers["content-disposition"]);
          // console.log(header);
          let index = header.indexOf("''");
          let fileName = header.substring(index + 2, header.length);
          console.log(fileName);
          const url = window.URL.createObjectURL(val);
          const link = document.createElement("a");
          link.download = fileName; // 设置a标签的下载属性
          link.style.display = "none";
          link.href = url;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href); // 下载完成释放URL 对象
          document.body.removeChild(link);
        })
        .catch()
        .finally();
      // );
    },
    InvoicingAll() {
      this.dialogVisible = true;
      this.type = "1";
      // this.$confirm("是否批量确认提现", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // })
      //   .then(() => {

      //   })
      //   .catch(() => {});
    },
    confrim() {
      if (this.status == "") {
        return;
      }
      if (this.status == "0") {
        if (this.failDesc == "") {
          this.$message({
            message: "请输入失败原因",
            type: "warning",
          });
          return;
        }
      }
      if (this.type == "0") {
        let param = {
          id: this.selectData.id,
          state: this.status,
          failDesc: this.failDesc,
        };
        this.$axios
          .post(`/admapi/withdraw/tempconfirm`, param)
          .then(({ data }) => {
            this.$message({
              message: "确认成功",
              type: "success",
            });
            this.dialogVisible = false;
            this.getList();
          })
          .catch()
          .finally();
      } else {
        if (this.multipleTable.length == 0) {
          this.$message({
            message: "请选择确认数据",
            type: "warning",
          });
          return;
        }
        let arr = [];
        for (var i = 0; i < this.multipleTable.length; i++) {
          arr.push(this.multipleTable[i].id);
        }
        let param = {
          ids: arr,
          state: this.status,
          failDesc: this.failDesc,
        };
        this.$axios
          .post(`/admapi/withdraw/tempbatchconfirm`, param)
          .then(({ data }) => {
            console.log(data);
            if (data.errorCount != 0) {
              this.errorList = data.errorMessages;
              this.dialogVisible1 = true;
            } else {
              this.$message({
                message: "批量确认成功",
                type: "success",
              });
            }
            this.multipleTable = [];
            this.$refs.multipleTable.clearSelection();
            this.getList();
            this.dialogVisible = false;
          })
          .catch()
          .finally();
      }
    },
    Invoicing(val) {
      if (val.status == 0) {
        let param = {
          id: val.id,
          state: "",
        };
        this.$axios
          .post(`/admapi/withdraw/tempconfirm`, param)
          .then(({ data }) => {
            this.$message({
              message: "提现打款中",
              type: "success",
            });
            this.getList();
          })
          .catch()
          .finally();
      } else {
        this.dialogVisible = true;
        this.type = "0";
        this.selectData = val;
      }
      // this.$confirm("是否确认提现", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // })
      //   .then(() => {

      //   })
      //   .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleTable = val;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "0";
      this.ruleForm.phone = "";
      this.ruleForm.id = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      if (this.ruleForm.name != "") {
        param.queryParams.push({
          name: "real_name",
          type: "input",
          value: this.ruleForm.name,
        });
      }
      if (this.ruleForm.phone != "") {
        param.queryParams.push({
          name: "phone",
          type: "input",
          value: this.ruleForm.phone,
        });
      }
      if (this.ruleForm.id != "") {
        param.queryParams.push({
          name: "bill_detail_no",
          type: "input",
          value: this.ruleForm.id,
        });
      }
      if (this.ruleForm.status != "") {
        param.queryParams.push({
          name: "status",
          type: "select",
          values: [{ itemKey: this.ruleForm.status }],
        });
      }
      this.$axios
        .post(`/admapi/withdraw/templist`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style>
.el-popover {
  padding: 0px 16px !important;
  box-sizing: border-box;
  border: none;
  min-width: 0;
}
</style>
